<template>
  <div class="product-item-wrapper">
    <div class="flex-table row product-item-wrapper-desktop" role="rowgroup">
      <div class="flex-row articul" role="cell">
        <span>{{ item.product.code }}</span>
      </div>
      <div class="flex-row name" role="cell">
        <nuxt-link class="link-ext" :to="localePath('/product/' + item.product.slug)"><span>{{ item.product.name }}</span></nuxt-link>
      </div>
      <div class="flex-row order order-qnt-edit" role="cell">
        <div>
          <a href="#" @click.prevent="decreaseAmount"><i class="svg-icon minus icon-pointer"></i></a>
          <input-number v-model="amount" :value="amount" :min-value="0" @update-value="updateAmount"/>
          <a href="#" @click.prevent="increaseAmount"><i class="svg-icon plus icon-pointer"></i></a>
        </div>
      </div>
      <div role="cell" class="flex-row del">
        <a class="circle" href="#" @click.prevent="$emit('set-delete-item', item.id)"><i
            class="svg-icon cross-little icon-pointer"></i></a>
      </div>
    </div>


    <div class="product-item product-item-wrapper-mobile">

      <div class="fav-code">
        <span>{{ item.product.code }}</span>
        <a class="circle" href="#" @click.prevent="$emit('set-delete-item', item.id)"><i
            class="svg-icon cross-little icon-pointer"></i></a>
      </div>

      <div class="name">
        <nuxt-link
          class="link-ext"
          :to="localePath('/product/' + item.product.slug)"><span>{{ item.product.name }}</span></nuxt-link>
      </div>

      <div class="order">
        <div>
          <a href="#" @click.prevent="decreaseAmount"><i class="svg-icon minus icon-pointer"></i></a>
          <input-number v-model="amount" :value="amount" :min-value="0" @update-value="updateAmount" />
          <a href="#" @click.prevent="increaseAmount"><i class="svg-icon plus icon-pointer"></i></a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {PriceRequestItem} from '@/models/price-request';

import InputNumber from '@/components/controls/input-number';

export default {
  props: ['item'],
  components: {
    InputNumber,
  },
  data() {
    return {
      amount: 0,
    }
  },
  created() {
    this.amount = this.item.amount;
  },
  methods: {
    decreaseAmount() {
      if (this.amount > 1) {
        this.amount--;
        this.updateAmount();
      }
    },
    increaseAmount() {
      this.amount++;
      this.updateAmount();
    },
    updateAmount() {
      const prevAmount = this.item.amount;
      this.item.amount = this.amount;
      let item = new PriceRequestItem(this.item);
      item.save().catch((e) => {
        this.item.amount = prevAmount;
        try {
          this.$notify({
            duration: 5000,
            text: e.response.data.detail || e.response.data.amount[0],
            ignoreDuplicates: true,
          });
        } catch (e) {
        }
      });
    },
  },
}
</script>
